export default function () {
    return function (data) {
        if (data.name) {
            return data.name;
        }

        let fullname = [data.firstName, data.lastName].join(' ');

        return [fullname, data.company].join(' @ ');
    }
}
